import { Link } from "react-router-dom";

const items = [
  {
    id: 1,
    label: "I",
    title: "Private Dining",
    image: "https://public.readdy.ai/ai/img_res/3158d2655cfc451c2a22edb58211fc80.jpg",
  },
  {
    id: 2,
    label: "II",
    title: "Luxury Events",
    image: "https://readdy.ai/api/search-image?query=grand%20long%20banquet%20dining%20table%20in%20a%20vaulted%20stone%20hall%20luxury%20private%20event%20tall%20white%20taper%20candelabras%20cascading%20white%20garden%20rose%20garland%20fog%20machine%20haze%20crystal%20goblets%20gold%20charger%20plates%20dark%20dramatic%20atmospheric%20lighting%20four%20seasons%20private%20event%20editorial%20cinematic%20photography&width=600&height=500&seq=exp-v3-002&orientation=landscape",
  },
  {
    id: 3,
    label: "III",
    title: "Bespoke Hospitality",
    image: "https://readdy.ai/api/search-image?query=white%20gloved%20sommelier%20hand%20elegantly%20pouring%20aged%20burgundy%20wine%20into%20wide%20crystal%20glass%20against%20pitch%20black%20background%20single%20candle%20warm%20pool%20of%20light%20chiaroscuro%20luxury%20hospitality%20service%20moment%20aman%20four%20seasons%20private%20dining%20cinematic%20editorial%20photography%20intimate%20refined&width=600&height=780&seq=exp-v3-003&orientation=portrait",
  },
  {
    id: 4,
    label: "IV",
    title: "Table & Atmosphere",
    image: "https://readdy.ai/api/search-image?query=ultra%20close%20up%20luxury%20table%20detail%20matte%20ivory%20porcelain%20plate%20with%20thin%20gold%20rim%20hand%20rolled%20linen%20napkin%20tied%20with%20satin%20ribbon%20sterling%20silver%20cutlery%20dried%20white%20lunaria%20florals%20single%20lit%20taper%20candle%20warm%20glow%20dark%20slate%20background%20editorial%20still%20life%20photography%20aman%20resort%20styling&width=600&height=500&seq=exp-v3-004&orientation=landscape",
  },
];

export default function SignatureExperiences() {
  return (
    <section className="bg-[#FAF8F5] py-28 md:py-36 px-8 md:px-16">
      <div className="max-w-7xl mx-auto">

        {/* Section header */}
        <div className="flex items-end justify-between mb-16 md:mb-20">
          <div>
            <span className="text-[#C9A961] tracking-[0.3em] text-[10px] uppercase font-light block mb-4">
              Experiences
            </span>
            <h2 className="font-serif text-[#1A1A1A] text-4xl md:text-5xl font-light leading-tight">
              Curated for the few.
            </h2>
          </div>
          <Link
            to="/experiences"
            className="hidden md:inline-flex items-center gap-2 text-[#8A7F74] hover:text-[#1A1A1A] text-[10px] tracking-[0.2em] uppercase font-light transition-colors cursor-pointer whitespace-nowrap"
          >
            View all
            <i className="ri-arrow-right-line text-sm" />
          </Link>
        </div>

        {/* Asymmetric editorial grid */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-5">

          {/* Large portrait — col 1–5 */}
          <div className="md:col-span-5 group overflow-hidden cursor-pointer relative">
            <div className="w-full h-[520px] md:h-[680px] overflow-hidden">
              <img
                src={items[0].image}
                alt={items[0].title}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
            </div>
            <div className="absolute bottom-0 left-0 p-7">
              <span className="text-[#C9A961] text-[10px] tracking-[0.3em] uppercase font-light block mb-2">{items[0].label}</span>
              <h3 className="font-serif text-white text-2xl font-light">{items[0].title}</h3>
            </div>
          </div>

          {/* Right column — stacked */}
          <div className="md:col-span-7 flex flex-col gap-4 md:gap-5">

            {/* Wide landscape top */}
            <div className="group overflow-hidden cursor-pointer relative">
              <div className="w-full h-[280px] md:h-[320px] overflow-hidden">
                <img
                  src={items[1].image}
                  alt={items[1].title}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
              </div>
              <div className="absolute bottom-0 left-0 p-7">
                <span className="text-[#C9A961] text-[10px] tracking-[0.3em] uppercase font-light block mb-2">{items[1].label}</span>
                <h3 className="font-serif text-white text-2xl font-light">{items[1].title}</h3>
              </div>
            </div>

            {/* Bottom row — two equal tiles */}
            <div className="grid grid-cols-2 gap-4 md:gap-5">
              {items.slice(2).map((item) => (
                <div key={item.id} className="group overflow-hidden cursor-pointer relative">
                  <div className="w-full h-[220px] md:h-[340px] overflow-hidden">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-transparent to-transparent" />
                  </div>
                  <div className="absolute bottom-0 left-0 p-5 md:p-6">
                    <span className="text-[#C9A961] text-[10px] tracking-[0.3em] uppercase font-light block mb-1.5">{item.label}</span>
                    <h3 className="font-serif text-white text-lg md:text-xl font-light">{item.title}</h3>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Mobile CTA */}
        <div className="mt-10 md:hidden">
          <Link
            to="/experiences"
            className="inline-flex items-center gap-2 text-[#8A7F74] hover:text-[#1A1A1A] text-[10px] tracking-[0.2em] uppercase font-light transition-colors cursor-pointer"
          >
            View all experiences
            <i className="ri-arrow-right-line text-sm" />
          </Link>
        </div>
      </div>
    </section>
  );
}
